import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";

export const settingValidate = values => {
    const errors = {};

    if (!values.value) {
        errors.value = plainJSTranslator.formatMessage(messages.required);
    }

    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/settings/settingValidate.js